<template>
  <div id="videos">
    <!--<v-expand-transition>-->
    <v-container class="mt-4" v-if="isVideoAdd">
      <v-form ref="formAdd">
        <v-layout wrap class="pb-3"> 
          <v-flex xs12 class="text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="cancel">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn v-if="isFileUpload" class="pf-btn pf-btn-save mr-0" @click="upload">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
              <v-btn v-else class="pf-btn pf-btn-save mr-0" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-layout wrap class="pa-3 grey lighten-4">
          <v-flex xs12 sm12>
            <v-text-field label="Provide YouTube or Vimeo video link"
                class="pr-5 pl-5" v-model="video.url" :rules="[videoLinkRule]"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pt-3 pb-3"> 
          <v-flex xs12 class="text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="cancel">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn v-if="isFileUpload" class="pf-btn pf-btn-save mr-0" @click="upload">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
              <v-btn v-else class="pf-btn pf-btn-save mr-0" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <!-- <v-flex class="text-sm-center or-label">
          <v-label><b>OR</b></v-label>
        </v-flex>

        <v-layout wrap class="pa-3 grey lighten-4">
          <v-flex xs12 sm4 md3 xl2 class="upload-container text-xs-center">
            <v-btn color="pf-btn-save" to="/video/create" dark>Create Video</v-btn>
            <ul class="text-xs-left">
              <li>You can choose the albums and photos</li>
              <li>You can choose/upload background music</li>
            </ul>
          </v-flex>
          <v-flex xs12 sm4 md3 xl2 class="upload-container text-xs-center">
            <v-btn color="pf-btn-save" @click="autoGenerateVideo" dark>Auto Generate Video</v-btn>
            <ul class="text-xs-left">
              <li>The system will choose all available albums for video and background music</li>
            </ul>
          </v-flex>
        </v-layout> -->
      </v-form>
    </v-container>
    <!--</v-expand-transition>-->
    <v-container class="pa-0" v-if="!isVideoAdd">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute right class="mr-3 pf-btn-fab" @click="isVideoAdd = true">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid>
      <!--<v-layout wrap class="pb-4">-->
        <draggable v-model="videoList" class="layout wrap row pb-4" handle=".handle" @start="drag=true" @end="drag=false;">
          <v-flex xs12 sm6 md6 lg4 xl3 pa-2 v-for="project of Project" :key="project.id">
            <router-link :to="{ path: `projects/${project.id}`}">
            <v-card
              class="theme--light rounded-corner" height="100%"
            >
            <v-responsive class="text-xs-center pa-2 pt-4">
              <img src="static/videoIcon.png">
            </v-responsive>
            <v-card-text class="title text-xs-center pt-4 pb-4">{{ project.title }}</v-card-text>
            </v-card>
            </router-link>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 xl3 v-for="videoItem of videoList" :key="videoItem.id" pa-2 >
            <v-card v-if="videoItem.url" height="100%" class="pf-pos-relative">
              <youtube v-if="videoItem.type === 'Youtube'" class="youtube-player" :video-id="getIdFromURL(videoItem.url)">
              </youtube>
              <!-- <vue-plyr :options="options" v-else-if="videoItem.type === 'Vimeo'">
                <div class="plyr__video-embed">
                  <iframe
                    :src="videoItem.url"
                    allowfullscreen allowtransparency>
                  </iframe>
                </div>
              </vue-plyr> -->
              <vimeo-player v-else-if="videoItem.type === 'Vimeo'" :video-url="videoItem.url" class="vimeo-embed-container" :options="{ responsive: true, controls: true, title: false }"></vimeo-player>

              <video v-else playsinline controls height="150" width="100%">
                <source :src="videoItem.url" />
              </video>
              <div v-if="typeof videoItem.approved !== 'undefined' && !videoItem.approved" class="pf-video-pending-label">PENDING APPROVAL</div>
              
              <v-flex class="pl-1 pr-1 mb-0">
                <h5 v-if="isSave == false || currentEditor != videoItem.id" id="videoName" class="pa-1 title-display">
                  <div v-on:click="editItem(videoItem, videoItem.id);">
                    <span v-if="videoItem.name">{{ videoItem.name }}</span>
                    <span v-else>Add title here</span>
                  </div>
                </h5>
                <v-text-field 
                  v-if="isSave && currentEditor == videoItem.id" 
                  v-model.trim="videoItem.name"
                  autofocus 
                  :hide-details="true"
                  class="pr-1 pt-1 text-edit-field" 
                  height="20" 
                  placeholder="Add title here"
                  @change="edit">
                </v-text-field>
              </v-flex>
              <v-divider horizontal></v-divider>
              <v-flex flat class="text-xs-right pa-1">
                <!--
                <v-btn icon class="ma-0" v-if="isSave == false || currentEditor != videoItem.id" v-on:click="editItem(videoItem, videoItem.id);">
                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                </v-btn>  
                <v-btn icon class="ma-0" v-if="isSave && currentEditor == videoItem.id" @click="edit">  
                  <v-icon size="22" color="grey darken-2">save</v-icon>
                </v-btn>
                -->
                
                <v-btn icon title="Cancel Edit" class="ma-0 handle" v-show="isSave && currentEditor == videoItem.id" @click="canceledit">
                  <v-icon size="22" color="grey darken-2">cancel</v-icon>
                </v-btn>
                <v-btn icon title="Edit" class="ma-0" :disabled="isSave && currentEditor == videoItem.id" @click="editItem(videoItem, videoItem.id)">
                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                </v-btn>
                <span v-if="sessionRole === 'agency'">
                  <v-btn icon title="Remove as Introduction" class="ma-0" v-if="videoItem.id == Agency.default_video">
                    <v-icon size="22" color="pink lighten-3">star</v-icon>
                  </v-btn>
                  <v-btn icon title="Set as Introduction" class="ma-0" v-if="videoItem.id != Agency.default_video" v-on:click="setIntroVideo(videoItem);" :disabled="videoItem.is_private">  
                    <v-icon size="22" color="grey darken-2">star_border</v-icon>
                  </v-btn>
                </span>
                <span v-else-if="typeof videoItem.approved === 'undefined' || videoItem.approved">
                  <v-btn icon title="Remove as Introduction" class="ma-0" v-if="videoItem.id === (session.role() === 'child' ? Child.default_video : Account.default_video)">
                    <v-icon size="22" color="pink lighten-3">star</v-icon>
                  </v-btn>
                  <v-btn icon title="Set as Introduction" class="ma-0" v-if="videoItem.id != (session.role() === 'child' ? Child.default_video : Account.default_video)" v-on:click="setIntroVideo(videoItem);" :disabled="videoItem.is_private">  
                    <v-icon size="22" color="grey darken-2">star_border</v-icon>
                  </v-btn>
                </span>
                <v-btn v-if="videoItem.is_private" icon title="Make Public" class="ma-0" v-on:click="togglePrivate(videoItem, 'public');" :disabled="videoItem.id === (session.role() === 'child' ? Child.default_video : Account.default_video)">
                  <v-icon size="22" color="pink lighten-3">visibility_off</v-icon>
                </v-btn>
                <v-btn v-else icon title="Make Private" class="ma-0" v-on:click="togglePrivate(videoItem, 'private');" :disabled="videoItem.id === (session.role() === 'child' ? Child.default_video : Account.default_video)">
                  <v-icon size="22" color="grey darken-2">visibility</v-icon>
                </v-btn>
                <v-btn icon title="Delete" class="ma-0" v-on:click="deleteItem(videoItem);">
                  <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                </v-btn>
              </v-flex>
              
            </v-card>
          </v-flex>
        <v-flex xs6 sm6>
        </v-flex>
      </draggable>
      <!--</v-layout>-->
    </v-container>
    <v-container grid-list-md fluid v-if="isListEmpty && !isVideoAdd && (session.role() !== 'parent' || isProjectEmpty)" class="text-center">
        <img src="static/NoVideos.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Video(s) Found !! </b></h4>
    </v-container>
  </div>
</template>
<script>
// import Videos from './Videos.vm.js';
/* global session, store */
import UploadButton from 'vuetify-upload-button';
import draggable from 'vuedraggable';
import swal from 'sweetalert2';
import { getCollection, update, remove, create, sortList, updateSortList, getOne, uploadFile, request, isYouTubeVideo } from '../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

// import VuePlyr from 'vue-plyr';
// import 'vue-plyr/dist/vue-plyr.css';
// Vue.use(VuePlyr);

import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
  components: {
    'upload-btn': UploadButton,
    draggable,
    'vimeo-player': vueVimeoPlayer
  },
  props:
  {
  },
  data: vm => ({
    entity: 'Video',
    roleEntity: 'Account',
    isListEmpty: false,
    isProjectEmpty: false,
    search: '',
    title: 'Select a video file',
    videoHeaders: [
      { text: 'Video', value: 'name', align: 'left' },
      { text: '', sortable: false },
    ],
    options: {
      controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen'],
    },
    editIndex: -1,
    editData: {},
    editItemData: {
      videoList: {
        index: -1,
        data: {}
      }
    },
    video: {
      name: '', url: '', size: '', type: ''
    },
    roleData: {},
    sessionRole: null,
    // videoList: [],
    isSave: false,
    currentEditor: null,
    currentEditorIndex: null,
    isVideoAdd: false,
    dialog: false,
    currentDeleteItem: null,
    // homeVideo: 1,
    isFileUpload: false,
    uploadFile: null,
    selectedFileItem: {},
    tempVideoLink: null,
    isVideoLinkValidated: false,
    selectedAlbums: []
  }),
  computed: {
    ...mapGetters(['Account', 'Agency', 'Child', 'Album', 'AlbumPhoto']),
    videoList: {
      get () {
        return store.state.Video;
      },
      set (value) {
        if (this.sessionRole === 'agency') {
          updateSortList(this.entity, value, 'Agency', session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        } else {
          updateSortList(this.entity, value, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
        }
        store.commit('setVideo', value);
      }
    },
    Project: {
      get () {
        return store.state.Project;
      },
      set (value) {
        store.commit('setProject', value);
      }
    },
    Music: {
      get () {
        return store.state.Music;
      },
      set (value) {
        store.commit('setMusic', value);
      }
    },
    albumList: {
      get () {
        return store.state.Album.filter(item => (item.photo.length > 0));
      },
      set (value) {
        store.commit('setAlbum', value);
      }
    }
  },
  watch: {
    Video (value) {
      this.videoList = value;
    },
    Project (value) {
      this.Project = value;
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : (['agency', 'caseworker'].indexOf(session.role()) > -1 ? 'Agency' : this.roleEntity);
    this.sessionRole = session.role();
    await this.initialize();
    if (this.sessionRole === 'parent') {
      await this.projectInitialize();
    }
  },
  methods: {
    getIdFromURL (url) {
      let a = url.split('/embed/')[1];
      return a;
    },
    videoLinkRule (url) {
      if (!this.isVideoLinkValidated) {
        if (url !== undefined || url !== '') {
          let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
          let match = url.match(regExp);
          if (match && match[2].length === 11) {
            this.tempVideoLink = url;
            return false;
          }
          else {
            let regExp2 = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
            let match2 = url.match(regExp2);
            if (match2) {
              this.tempVideoLink = 'https://player.vimeo.com/video/' + match2[3];
              return false;
            } else {
              return 'Please enter a video url';
            }
          }
        }
      } else {
        return false;
      }
    },
    async initialize () {
      let sessionUser = session.getSession();
      let where = {};
      if (sessionUser.adminUser) {
        if (this.sessionRole === 'agency') {
          where.agency = sessionUser.user.human.agency;
        } else {
          where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
        }
      }
      let { error, data } = await getCollection(this.entity, true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          if (this.sessionRole === 'agency') {
            this.videoList = sortList(this.entity, data, 'Agency', sessionUser.adminUser ? sessionUser.user.human.agency : 'Me');
          } else {
            let allTypes = await sortList(this.entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
            this.videoList = allTypes.filter(video => video.type !== 'File');
          }
        } else {
          this.isListEmpty = true;
        }
      }
    },
    async projectInitialize () {
      if (!this.Project.length) {
        let populate = [{ path: 'section.section', populate: 'items.item' }];
        let where = {};
        where[this.roleEntity.toLowerCase()] = this[this.roleEntity].id;

        let { error, data } = await getCollection('Project', true, 0, populate, where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setProject', data);
          } else {
            this.isProjectEmpty = true;
          }
        }
      }
    },

    // eslint-disable-next-line
    async save () {
      if (this.$refs.formAdd.validate()) {
        
        this.video.type = isYouTubeVideo(this.tempVideoLink) ? 'Youtube' : 'Vimeo';

        /* Check if the vimeo video is publicly accessible */
        if (this.video.type === 'Vimeo') {
          let regExp = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
          let videoParts = this.video.url.match(regExp);
          let videoId = null;
          if (videoParts && videoParts[3]) {
            videoId = videoParts[3];
          }
          if (videoId) {
            let accessibility = await request(`Video/VimeoData/${videoId}`, 'GET');
            let message = null;
            if (!accessibility || accessibility.error) {
              message = 'Failed to fetch the video details, please try again.';
            } else if (accessibility.data && accessibility.data.privacy && ['anybody', 'unlisted'].indexOf(accessibility.data.privacy.view) === -1) {
              message = 'The video is not public, please change the video privacy and try again.';
            }
            if (message) {
              swal.fire({
                type: 'warning',
                title: 'Video Error',
                text: message,
                showConfirmButton: true,
                onClose: () => {
                  // 
                }
              });
              return;
            }
          }
        }
        this.isListEmpty = false;
        this.isVideoAdd = false;
        this.video.name = '';
        this.video.url = this.tempVideoLink;
        this.isVideoLinkValidated = true;
        if (session.getSession().adminUser) {
          if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
            this.video.agency = session.getSession().user.human.agency;
          } else {
            this.video[this.roleEntity.toLowerCase()] = session.getSession().user.human[this.roleEntity.toLowerCase()].id;
          }
        }
        let { error, data, status } = await create(this.entity, this.video);
        if (error) {
          console.log('error', error);
        } else {
          this.loading = false;
          if (this.videoList.length === 0) {
            if (this.sessionRole === 'agency') {
              this.Agency.default_video = data.id;
            } else {
              this[this.roleEntity].default_video = data.id;
            }
          }
          this.videoList.unshift(data);
          let videoItem = {
            sort_no: 0,
            video: data.id
          };
          if (this.sessionRole === 'agency') {
            this.Agency.video.unshift(videoItem);
          } else {
            this[this.roleEntity].video.unshift(videoItem);
          }
          let alert = data.approved ? 'Video added successfully' : 'Video was submitted for review';
          swal.fire({
            type: 'success',
            title: alert,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.video.type = '';
              this.video.url = '';
              this.isVideoAdd = false;
              this.isFileUpload = false;
              this.videoList = sortList(this.entity, this.videoList, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
              this.tempVideoLink = null;
              this.isVideoLinkValidated = false;
            }
          });
        }
      }
    },

    async autoGenerateVideo () {
      let payload = {};
      payload[this.roleEntity.toLowerCase()] = this[this.roleEntity].id;
      payload.keywords = [];
      payload.text_slides = [];

      /* Load the musics */
      await this.getMusic();

      if (!this.Music.length || !this.Music[0].file || !this.Music[0].file.webPath) {
        swal.fire({
          type: 'warning',
          title: 'No music found',
          text: 'No musics were found in the system, please check with your agency',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      payload.music = this.Music[0].file.webPath;
      await this.getAlbums();
      await this.addAllAlbums();
      payload.album = this.selectedAlbums;
      if (this.selectedAlbums.length) {
        let { error, data } = await create('Video/Create', payload);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          swal.fire({
            type: 'success',
            title: 'Video create request has been submitted, please check back soon.',
            showConfirmButton: false,
            timer: 3500,
            onClose: () => {
              this.$router.push({ path: '/videos' });
            }
          });
        }
      } else {
        swal.fire({
          type: 'warning',
          title: 'No photos found',
          text: 'No photos were found in any albums, please upload album photos and try again',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
    },

    async getMusic () {
      if (!this.Music.length) {
        let sort = { sort_no: 1 };
        let { error, data } = await getCollection('Music', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Music = data;
          }
        }
      }
    },
    async getAlbums () {
      let sessionUser = session.getSession();
      let where = {};
      if (sessionUser.adminUser) {
        where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
      }
      if (!this.albumList.length) {
        let { error, data } = await getCollection('Album', true, 0, '', where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList('Album', data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
          }
        }
      }
    },
    async addAllAlbums () {
      let normalAlbums = this.Album.filter(album => album.type === 'Normal' && album.photo.length);
      if (normalAlbums.length) {
        for (let i = 0; i < normalAlbums.length; i++) {
          let album = normalAlbums[i];
          await this.addAlbum(album);
        }
      }
    },

    async addAlbum (albumItem) {

      await this.getPhotos(albumItem.id);
      let index = this.selectedAlbums.findIndex(album => album.id === albumItem.id);
      if (index === -1 && this.AlbumPhoto[albumItem.id]) {
        let album = {
          id: albumItem.id,
          name: albumItem.name,
          photo: []
        };
        for (let i = 0; i < this.AlbumPhoto[albumItem.id].length; i++) {
          let photo = this.AlbumPhoto[albumItem.id][i];
          photo = {
            id: photo.id,
            caption: photo.caption ? photo.caption : '',
            thumb_url: photo.thumb_url,
            webview_url: photo.webview_url,
            original_url: photo.original_url
          };
          album.photo.push(photo);
        }
        if (album.photo.length) {
          this.selectedAlbums.push(album);
        }
      }
    },
    async getPhotos (albumId) {
      if (!this.AlbumPhoto[albumId]) {
        let { error, data } = await getOne('Album', albumId);
        if (error) {
          console.log('error', error);
        } else {
          const photos = [];
          for (let i = 0; i < data.photo.length; i++) {
            photos.push(data.photo[i].photo);
            data.photo[i].photo = data.photo[i].photo.id;
          }
          this.album = data;
          this.AlbumPhoto[albumId] = photos;
        }
      }
    },
    editItem (item, id) {
      this.currentEditor = item.id;
      this.isSave = true;
      this.editData = item;
      this.currentEditorIndex = this.videoList.indexOf(item);
    },

    canceledit () {
      this.isSave = false;
      this.currentEditor = null;
      this.currentEditorIndex = null;
      this.editData = {};
    },

    async edit () {
      if (this.editData.id) {
        let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
        if (error) {
          console.log('error', error);
        } else {
          this.videoList[this.currentEditorIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Video updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.videoList[this.currentEditorIndex].id = this.currentEditor;
              this.currentEditor = null;
              this.currentEditorIndex = null;
              this.isSave = false;
            }
          });
        }
      }
    },

    async setIntroVideo (videoItem) {

      if (!videoItem.is_private) {
        
        let deleteEntity = '';
        if (this.sessionRole === 'agency') {
          this.Agency.default_video = videoItem.id;
          this.roleData = this.Agency;
          deleteEntity = `Agency`;
        } else {
          this[this.roleEntity].default_video = videoItem.id;
          this.roleData = this[this.roleEntity];
          this.roleData.updated_from = 'videos';
          deleteEntity = this.roleEntity;
        }
        
        let entityId = deleteEntity === this.roleEntity ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : session.getSession().user.human.agency;
        let { error, data, status } = await update(deleteEntity, this.roleData, session.getSession().adminUser ? entityId : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Introduction video updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        }
      } else {
        swal.fire({
          type: 'warning',
          title: 'Private Video',
          text: 'Introduction video should be public!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }
    },  
  
    deleteItem (item) {
      if (this.sessionRole === 'agency') {
        this.currentDeleteItem = this.Agency.default_video;
      } else {
        this.currentDeleteItem = this[this.roleEntity].default_video;
      }
      if (item.id !== this.currentDeleteItem || (item.id === this.currentDeleteItem && this.videoList.length === 1)) {
        swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            (async () => {
              let { error, data, status } = await remove(this.entity, item.id);
              if (error) {
                console.log('error', error);
              } else {
                const index = this.videoList.indexOf(item);
                this.videoList.splice(index, 1);
                if (this.videoList.length === 0) this.isListEmpty = true;
                let entity = this.sessionRole === 'agency' ? 'Agency' : this.roleEntity;
                let deletedVideoItem = this[entity].video.find(video => video.video === item.id);
                this[entity].video.splice(this[entity].video.indexOf(deletedVideoItem), 1);
                swal.fire(
                  'Deleted!',
                  'The video ' + item.name + ' has been deleted.',
                  'success'
                );
              }
            })();
          }
        });
      } else {
        swal.fire({
          type: 'warning',
          title: 'Introduction Video',
          text: 'Please set another video as introduction to delete this!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        // this.dialog = true;
      }
    },

    async togglePrivate (item, visibility) {
      
      let videoIndex = this.videoList.findIndex(x => x.id === item.id);
      let updateData = JSON.parse(JSON.stringify(item));
      if (visibility === 'private') {
        updateData.is_private = true;
      } else {
        updateData.is_private = false;
      }
      if (updateData.id !== this[this.roleEntity].default_video) {
        let { error, data, status } = await update(this.entity, updateData, updateData.id);
        if (error) {
          console.log('error', error);
        } else {
          this.videoList[videoIndex] = data;
          this.videoList = this.videoList;
          swal.fire(
            'Success!',
            'The video ' + item.name + ' has been set as ' + visibility + '.',
            'success'
          );
        }
      } else {
        swal.fire({
          type: 'warning',
          title: 'Introduction Video',
          text: 'Introduction video visibility cannot be changed!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }
    },

    fileSelected (files) {
      this.selectedFileItem = files;
      this.isFileUpload = true;
      let type = '';
      if (files) type = this.selectedFileItem.type.split('/')[0];
      if (this.selectedFileItem && this.selectedFileItem.name && type === 'video') {
        this.title = this.selectedFileItem.name;
      } else {
        this.selectedFileItem = {};
        this.title = 'Select a video file';
        this.isFileUpload = false;
        swal.fire({
          type: 'error',
          title: 'Invalid Video file',
          text: 'Please select Video file only!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }
    },
    cancel () {
      this.isVideoAdd = false;
      this.video.url = '';
      this.video.type = '';
      this.title = 'Select a video file';
      this.isFileUpload = false;


    },
    async upload () {
      let files = this.selectedFileItem;
      // start here
      if (files) {
        if (files !== 'undefined') {
          this.fileName = files.name;
          if (this.fileName.lastIndexOf('.') <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files);
          fr.addEventListener('load', async () => {
            let postUrl = 'Video/Upload';
            let response = await uploadFile(postUrl, files, 'POST');
            if (!response.$data) {
              console.log('error', response.$error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: response.$error
              };
            } else {
              this.loading = false;
              if (this.videoList.length === 0) {
                if (this.sessionRole === 'agency') {
                  this.Agency.default_video = response.$data.id;
                } else {
                  this[this.roleEntity].default_video = response.$data.id;
                }
              }
              this.videoList.unshift(response.$data);
              swal.fire({
                type: 'success',
                title: 'Video uploaded successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  this.title = 'Select a video file';
                  this.video.url = '';
                  this.isVideoAdd = false;
                  this.isFileUpload = false;
                  this.videoList = sortList(this.entity, this.videoList, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
                }
              });
            }
          });
        }
      }
      // ends here
    }
  }
};

// export default Videos;
</script>

<style lang="stylus" scoped>
  .pf-divider {
    margin: 0 auto;
    width: 88%;
  }
  .upload-container{
    padding-top: 10px;
    padding-bottom: 20px;
    margin: 0 auto;
  }
  .pf-video-upload-btn{
    padding-left: 0;
    padding-right: 0;
  }
  .or-label{
    padding: 25px 0;
  }
  .title-display{
    padding-top: 6px !important;
  }
  .text-edit-field {
    padding-left: 4px;
    padding-bottom: 6px;
  }
  @media(max-width:576px){
    .or-label{
      padding-top: 0;
    }
  }

.title {
  color: #019d8c !important;
}

.rounded-corner {
    border-radius: 2px;
    border : 2px solid #019d8c !important;
}

#videos >>> .youtube-player {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
}

#videos >>> .youtube-player iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/Videos.vue